import * as React from "react";
import { Tooltip } from "react-bootstrap";
import I18n, { PrefixedKeys } from "lib/I18n";

function createTooltip(messageKey: PrefixedKeys<"raw_post_viewer.messages.">) {
  return (
    <Tooltip id={`tooltip_${messageKey}`}>
      {I18n.t(`raw_post_viewer.messages.${messageKey}`)}
    </Tooltip>
  );
}

const tooltips: { [index: string]: JSX.Element } = {
  has_data_type_error: createTooltip("has_data_type_error"),
  has_undefined_keys: createTooltip("has_undefined_keys"),
  event_master_not_defined: createTooltip("event_master_not_defined"),
  add_hex_data_key: createTooltip("add_hex_data_key"),
  remove_hex_data_key: createTooltip("remove_hex_data_key"),
};

export default tooltips;
